import { useInfiniteQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { transactionKeys } from '../transactionQueryKeys'
import { getTransactions } from '../transactionEndpoints'
import type { ParsedTransactionsPage } from '../transactionParser'
import type { TransactionFilters } from '../../types/transactionTypes'

const PAGE_LIMIT = 20

export function useTransactionsQuery(
  filters: MaybeRefOrGetter<TransactionFilters>,
  /** Skip the request entirely — used when a screen has two possible sources. */
  enabled: MaybeRefOrGetter<boolean> = true,
) {
  return useInfiniteQuery<ParsedTransactionsPage>({
    enabled: () => toValue(enabled),
    queryKey: () => transactionKeys.list(toValue(filters)),
    queryFn: ({ pageParam }) =>
      getTransactions({ page: pageParam, limit: PAGE_LIMIT, filters: toValue(filters) }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      allPages.length < lastPage.pagination.totalPages ? allPages.length + 1 : undefined,
  })
}
